/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartPieA1Icon24Solid = forwardRef('DataChartPieA1Icon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M11 2.05C5.947 2.55 2 6.814 2 12c0 5.523 4.477 10 10 10s10-4.477 10-10a9.964 9.964 0 0 0-.881-4.11L12.5 12.866A1 1 0 0 1 11 12V2.05Z" }),
        React.createElement("path", { d: "M13 2.05a9.992 9.992 0 0 1 7.117 4.109L13 10.268V2.049Z" })));
});
